import React from 'react';

import DocumentTitle from 'react-document-title';
import { defineMessages, useIntl } from 'react-intl';

import FabricAnalyticsListeners, { FabricChannel } from '@atlaskit/analytics-listeners';
// eslint-disable-next-line @atlaskit/design-system/no-deprecated-imports
import { Content, Main, PageLayout, TopNavigation } from '@atlaskit/page-layout';
import { useAnalytics } from '@atlassian/ptc-common';

import { Navigation } from './/Navigation';

interface Props {
	children: React.ReactNode;
	chromeless?: boolean;
}

const CoreLayout = (props: Props): React.JSX.Element => {
	const analytics = useAnalytics();

	const intl = useIntl();

	return (
		<DocumentTitle title={intl.formatMessage(messages.pageTitle)}>
			{props.chromeless ? (
				<React.Fragment>{props.children}</React.Fragment>
			) : (
				<PageLayout>
					<FabricAnalyticsListeners
						// @ts-ignore Analytics web client types mismatch
						client={analytics.getAnalyticsWebClient()}
						excludedChannels={[
							FabricChannel.atlaskit,
							FabricChannel.elements,
							FabricChannel.editor,
							FabricChannel.media,
						]}
					>
						<TopNavigation isFixed>
							<Navigation />
						</TopNavigation>
					</FabricAnalyticsListeners>

					<Content>
						<Main>{props.children}</Main>
					</Content>
				</PageLayout>
			)}
		</DocumentTitle>
	);
};

const messages = defineMessages({
	pageTitle: {
		id: 'pf-home.home.page-title',
		defaultMessage: 'Atlassian People',
		description:
			'Browser tab title displayed for the Atlassian People directory application when viewing standalone',
	},
});

export default CoreLayout;
